import { Link, useNavigate, useLocation } from "react-router-dom";
import { LinkedinLogo, InstagramLogo, FacebookLogo, ArrowUpRight } from "@phosphor-icons/react";
import { t } from "../i18n";
import { Logo } from "./Navbar";

export default function Footer() {
  const f = t.de.footer;
  const nav = useNavigate();
  const loc = useLocation();

  const goHome = (hash) => {
    if (loc.pathname !== "/") nav("/" + (hash ? `#${hash}` : ""));
    else document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative bg-navy-900 text-white pt-24 pb-10 overflow-hidden grain">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold-500/10 rounded-full blur-3xl" />
      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">{f.tagline}</p>
            <p className="mt-4 text-gold-400 text-sm tracking-wide">{t.de.slogan}</p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm uppercase tracking-[0.2em] text-gold-500 mb-5">{f.col1}</h4>
            <ul className="space-y-3 text-white/70">
              <li><button onClick={() => goHome("")} className="hover:text-gold-400 transition-colors">{t.de.nav.home}</button></li>
              <li><button onClick={() => goHome("about")} className="hover:text-gold-400 transition-colors">{t.de.nav.about}</button></li>
              <li><button onClick={() => goHome("services")} className="hover:text-gold-400 transition-colors">{t.de.nav.services}</button></li>
              <li><Link to="/kontakt" className="hover:text-gold-400 transition-colors">{t.de.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm uppercase tracking-[0.2em] text-gold-500 mb-5">{f.col2}</h4>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/datenschutz" className="hover:text-gold-400 transition-colors">{f.privacy}</Link></li>
              <li><Link to="/impressum" className="hover:text-gold-400 transition-colors">{f.legal}</Link></li>
              <li><Link to="/software" className="hover:text-gold-400 transition-colors">{t.de.nav.software}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm uppercase tracking-[0.2em] text-gold-500 mb-5">{f.follow}</h4>
            <div className="flex gap-3">
              {[LinkedinLogo, InstagramLogo, FacebookLogo].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-${i}`}
                  className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-gold-500 hover:border-gold-500 transition-all"
                  aria-label="Social Media"
                >
                  <Icon size={20} weight="regular" />
                </a>
              ))}
            </div>
            <Link
              to="/kontakt"
              className="mt-8 inline-flex items-center gap-2 text-white hover:text-gold-400 transition-colors group"
              data-testid="footer-cta"
            >
              {t.de.nav.quote}
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-white/40 text-sm">
          <p>© {new Date().getFullYear()} CLEANSORA. {f.rights}</p>
          <p>Gebäude- & Solarreinigung</p>
        </div>
      </div>
    </footer>
  );
}
